import React, { useState } from 'react';
import "./InterviewForm.css";
import Button from './Button';

function InterviewForm() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        project: ''
    });
    
    const [errors, setErrors] = useState({});

    const validate = () => {
        let newErrors = {};
        if (!formData.name.trim()) newErrors.name = "Name is required";
        if (!formData.phone.trim()) {
            newErrors.phone = "Phone number is required";
        } else if (!/^\+?[1-9]\d{1,10}$/.test(formData.phone)) {
            newErrors.phone = "Invalid phone number format";
        }
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }
        if (!formData.project.trim()) newErrors.project = "Project details are required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            console.log("Form submitted successfully", formData);
        }
    };

    return (
        <section className='interview-form-section'>
            <div className='interview-content'>
                <h2>Schedule a Developer <span>Interview</span></h2>
                <p>Share some more information about skill set you are looking for and we will find the right candidate for you.</p>
            </div>
            <form className="interview-form" onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="input-group">
                        <label htmlFor="name">Name *</label>
                        <input type="text" id="name" placeholder="Enter your name" value={formData.name} onChange={handleChange} />
                        {errors.name && <span className="error">{errors.name}</span>}
                    </div>
                    <div className="input-group">
                        <label htmlFor="phone">Phone Number *</label>
                        <input type="tel" id="phone" placeholder="Enter your phone number" value={formData.phone} onChange={handleChange} />
                        {errors.phone && <span className="error">{errors.phone}</span>}
                    </div>
                </div>
                <div className="input-group">
                    <label htmlFor="email">Mail *</label>
                    <input type="email" id="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} />
                    {errors.email && <span className="error">{errors.email}</span>}
                </div>
                <div className="input-group">
                    <label htmlFor="project">Project Details *</label>
                    <textarea id="project" placeholder="Tell us about your idea" value={formData.project} onChange={handleChange}></textarea>
                    {errors.project && <span className="error">{errors.project}</span>}
                </div>
                <div className='hire-btn'>
                    <Button btnTitle={`Inquire Now`} />
                </div>
            </form>
        </section>
    );
}

export default InterviewForm;